import { render, staticRenderFns } from "./ProjectInfoBox.vue?vue&type=template&id=80298ea0"
import script from "./ProjectInfoBox.vue?vue&type=script&lang=ts"
export * from "./ProjectInfoBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports